import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import styles from './RouteError.module.css';

/** Router-level error boundary for unexpected render/loader failures. */
export function RouteError() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? `${error.status} — ${error.statusText}`
    : 'An unexpected error occurred.';

  return (
    <div className={styles.wrap}>
      <h1 className={styles.title}>Something went wrong</h1>
      <p className={styles.message}>{message}</p>
      <Link to="/" className={styles.link}>
        Return home
      </Link>
    </div>
  );
}
